var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { getAllMonths, getNow, updateDate } from 'src/shared/helpers/dateHelpers';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
import Select from 'src/ui/components/Input/Select';
/**
 * @param pathToTemporality Object key path, but stops just before last level (day / month / year)
 * @param onChange side effects triggered on input value changes
 * @param timeUnit
 * @param additionnalProps all potential props from classic <Select> component that needs to be specified, can be used to override default behavior
 * @returns
 */
export var SelectDateInputValidIdentity = function (props) {
    var validIdentityModalInfo = props.validIdentityModalInfo, pathToTemporality = props.pathToTemporality, onChange = props.onChange, timeUnit = props.timeUnit, label = props.label, additionnalProps = __rest(props, ["validIdentityModalInfo", "pathToTemporality", "onChange", "timeUnit", "label"]);
    var i18n = validIdentityModalInfo.i18n, currentIdentity = validIdentityModalInfo.currentIdentity, currentIdentityModified = validIdentityModalInfo.currentIdentityModified, currentValidation = validIdentityModalInfo.currentValidation, getInputHint = validIdentityModalInfo.getInputHint;
    var isMonthUnit = timeUnit === 'month';
    var allMonths = getAllMonths();
    var now = getNow();
    var daysInDateMonth = getPropsByKeyPath(currentIdentityModified, pathToTemporality)
        ? updateDate(now, {
            month: getPropsByKeyPath(currentIdentityModified, "".concat(pathToTemporality, ".month")),
            year: getPropsByKeyPath(currentIdentityModified, "".concat(pathToTemporality, ".year")),
        }).daysInMonth
        : now.daysInMonth;
    var daysInDateMonthOption = Array.from({ length: daysInDateMonth }, function (item, index) { return (index + 1).toString(); });
    var fullPath = "".concat(pathToTemporality, ".").concat(timeUnit);
    var alternatePath = "".concat(pathToTemporality).concat(timeUnit);
    var date = getPropsByKeyPath(currentIdentity, fullPath);
    var dateModified = getPropsByKeyPath(currentIdentityModified, fullPath);
    var dateValidation = getPropsByKeyPath(currentValidation, alternatePath);
    var dateLabel = label !== null && label !== void 0 ? label : getPropsByKeyPath(i18n.keyValueMap, "caseGlobalView.modals.identityValidation.inputLabels.".concat(timeUnit));
    var isDateChanged = date !== dateModified;
    return (_jsx(Select, __assign({ options: isMonthUnit ? allMonths : daysInDateMonthOption, value: isMonthUnit ? allMonths[dateModified - 1] : dateModified, onChange: onChange, label: dateLabel, withInfo: isDateChanged || (dateValidation === null || dateValidation === void 0 ? void 0 : dateValidation.isError), isError: dateValidation === null || dateValidation === void 0 ? void 0 : dateValidation.isError, infoMessage: (dateValidation === null || dateValidation === void 0 ? void 0 : dateValidation.isError) ? dateValidation.infoMessage : getInputHint(isMonthUnit ? allMonths[date - 1] : date) }, additionnalProps)));
};
